import * as React from "react";
import {Footer} from '../../component/layout/Footer';
import {Navigation} from '../../component/layout/Navigation';
import {VoDusunGridItem} from '../../component/village-organization/VoDusunGridItem';
import {OrganizationApiService} from "../../core/api/organization/OrganizationApiService";
import {IReadOrganizationResponse} from "../../core/api/organization/response/ReadOrganizationResponse";

interface IProps {
    componentName?: string;
}

interface IState {
    data: IReadOrganizationResponse[] | undefined;
}

export class VoDusun extends React.Component<IProps, IState> {

    private readonly apiService = new OrganizationApiService();

    constructor(props: IProps) {
        super(props);

        this.state = {
            data: undefined
        }
    }

    public componentDidMount = () =>{
        this.fetchData();
    };

    public render() {
        return (
            <div id="vo-dusun-page" className="page client-area">
                <Navigation navClass="main-nav js-stick" />

                <section className="page-section bg-dark-alfa-30 parallax-3 dusun-header-section">
                    <div className="relative container align-left">
                        <div className="row">
                            <div className="col-md-8">
                                <h1 className="hs-line-11 font-alt mb-20 mb-xs-0">Dusun</h1>
                                <div className="hs-line-4 font-alt black">Daftar Dusun desa Sanur Kauh</div>
                            </div>
                            <div className="col-md-4 mt-30">
                                <div className="mod-breadcrumbs font-alt align-right"><a
                                    href="/">Beranda</a>&nbsp;/&nbsp;Informasi Desa&nbsp;/&nbsp;Dusun</div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="page-section">
                    <div className="container relative">
                        <div className="row">
                            <div className="col-sm-10 col-sm-offset-1">

                                {this.state.data === undefined ? <p>Loading...</p> : (
                                    <div>
                                        {this.state.data.length < 1 ? <p>Data tidak ditemukan.</p> : this.state.data.map((item, index) =>
                                            <VoDusunGridItem key={index} data={item}  />
                                        )}
                                    </div>
                                )}

                                {/*<div className="pagination">
                                    <a className="active" href="blog-classic-sidebar-right.html">1</a>
                                    <a href="blog-classic-sidebar-right.html">2</a>
                                    <a href="blog-classic-sidebar-right.html">3</a>
                                    <a className="no-active">...</a>
                                    <a href="blog-classic-sidebar-right.html">9</a>
                                </div>*/}

                            </div>
                        </div>
                    </div>
                </section>

                <Footer />
            </div>
        );
    }

    private fetchData = () => {
        this.apiService.getDusun()
            .then((response: any) => {
                this.setState({
                    data: response.result
                })
            }).catch((error) => {
            this.setState({
                data: []
            })
        })
    }
}


// WEBPACK FOOTER //
// ./src/screen/village-organization/VoDusun.tsx